var MDB = window.MDB || {};;
MDB.DPN = MDB.DPN || {};
MDB.DPN.Retention = MDB.DPN.Retention || {};

(function ($, MDB) {
    var grid = $('#grid')
        , crudBaseUrl = document.location.origin + '/api/DPN/Retention'
        , searchForm = $('#search-form')
        , config = grid.data('config')
        , requiredFormElements;


    $.extend(MDB.DPN.Retention, {
        boot: function () {
            config.model.fields.isPreservation = { type: 'boolean' };
            config.model.fields.state = { type: 'number' };
            config.model.fields.smsReceived = { type: 'boolean' };
            config.model.fields.free = {
                type: 'string',
                validation: {
                    free: function (input) {
                        //For some reason all fields are validated, ensure we only validate the 'free' field
                        var $input = $(input);
                        if ($input.attr('name') === 'free') {
                            var value = $input.val();

                            if (_.uniq(_.toArray(value)).length < 5) {
                                return false;
                            }

                            var result = _.filter(_.split(value, ' '), function (word) {
                                return word.length >= 2;
                            });

                            return result.length >= 4;
                        }

                        return true;
                    }
                }
            };

            config.columns.forEach(function (column) {
                column.encoded = false;

                var field = config.model.fields[column.field];
                if (field && field.type) {
                    if (field.type === 'boolean') {
                        column.template = MDB.KendoConfigBuilder.gridBooleanYesNoTemplate(column.field);
                    }
                }
            });

            config.columns.push({
                field: 'smsReceived',
                title: MDB.loadResourceString('RetentionAddStateModel_SmsReceived_DisplayName'),
                hidden: true,
                template: MDB.KendoConfigBuilder.gridBooleanYesNoTemplate('smsReceived'),
                editable: {
                    template: MDB.KendoConfigBuilder.gridCheckboxTemplate('smsReceived')
                }
            }, {
                field: 'isPreservation',
                title: MDB.loadResourceString('RetentionAddStateModel_IsPreservation_DisplayName'),
                hidden: true,
                template: MDB.KendoConfigBuilder.gridBooleanYesNoTemplate('isPreservation'),
                editable: {
                    template: MDB.KendoConfigBuilder.gridCheckboxTemplate('isPreservation')
                }
            }, {
                field: 'state',
                title: MDB.loadResourceString('RetentionAddStateModel_State_DisplayName'),
                hidden: true,
                editor: stateDropdownEditor
            }, {
                field: 'free',
                title: MDB.loadResourceString('RetentionAddStateModel_Free_DisplayName'),
                hidden: true,
                editor: function (container) {
                    MDB.KendoConfigBuilder.gridTextAreaEditor(container, 'free', {
                        required: true,
                        validationMessage: MDB.loadResourceString('RetentionAddStateModel_Free_RequiredMessage')
                    })
                }
            });
            
            config.columns.unshift(MDB.KendoConfigBuilder.gridCommandColumn({
                name: 'edit',
                text: {
                    edit: MDB.loadResourceString('RetentionAddStateModel_EditButton_DisplayName'),
                    update: MDB.loadResourceString('RetentionAddStateModel_UpdateButton_DisplayName'),
                    cancel: MDB.loadResourceString('RetentionAddStateModel_CancelButton_DisplayName')
                }
            }));

            var dataSource = new kendo.data.DataSource({
                transport: {
                    read: function (opts) {
                        var url = crudBaseUrl + '/search/?' + searchForm.serialize();
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'GET', opts);
                    },
                    update: function (opts) {
                        opts.error = function (res) {
                            MDB.alert('Er is een fout opgetreden bij het verwerken, probeer het opnieuw');
                        };

                        var url = crudBaseUrl + '/State/';
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'PUT', opts);
                    }
                },
                error: function (e) {
                    MDB.alert(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e));
                },
                pageSize: 20,
                autoSync: false,
                schema: {
                    model: config.model
                }
            });

            grid.kendoGrid({
                dataSource: dataSource,
                pageable: false,
                autoBind: false,

                columns: config.columns,
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                navigatable: true,
                sortable: { mode: 'multiple' },
                scrollable: false,
                editable: 'popup',

                edit: function (e) {
                    MDB.KendoConfigBuilder.hideColumnsOnEdit(e);

                    preloadEditorValues(e);
                }
            });

            searchForm.on('submit', function (e) {
                e.preventDefault();

                if ($(this).valid()) {
                    dataSource.read();
                }
            });

            $('body').on('change', '[name="isPreservation"]', function (e) {
                //Fetch dropdownlist values for current preservation state
                var formContainer = $(e.target).closest('.k-edit-form-container');
                $(formContainer).find('[name="state"]')
                    .data('kendoDropDownList')
                    .dataSource
                    .read();
            });

            function preloadEditorValues(e){
                MDB.callApi({
                    url: '/DPN/Retention/State?id=' + e.model.leadid,
                    success: function (data) {
                        if(!data) {
                            return;
                        }

                        var inputElements = e.container.find('input, textarea')
                            , dropdownLists = [];

                        Object.keys(data).forEach(function (key) {
                            //Case incensitive attribute search is not supported by jQuery selector->find
                            //Find matching input element by name
                            var inputElement = inputElements.filter(function () {
                                return $(this).attr('name').toLowerCase() === key.toLowerCase();
                            });

                            var value = data[key],
                                field = inputElement.attr('name');

                            if(!value || !field) {
                                return;
                            }
                            
                            if (inputElement.attr('type') === 'checkbox'){
                                inputElement.prop('checked', !!value);
                            } else {
                                var dropdownlist = inputElement.data('kendoDropDownList');
                                if(dropdownlist){
                                    dropdownLists.push({
                                        item: dropdownlist,
                                        value: value
                                    });
                                } else {
                                    inputElement.val(value);
                                }
                            }

                            setFieldValue(e.model.id, field, value);
                        });

                        //Wait until all elements are loaded before initializing dropdownlist value
                        //State dropdownlist bases it's values on the value of isPreservation
                        dropdownLists.forEach(function(i){
                            i.item.dataSource.read();
                            i.item.value(i.value);
                        });
                    }
                });
            }

            function stateDropdownEditor(e, opts) {
                var $formContainer = $(e.context);

                $(sprintf('<input name="%s" />', opts.field))
                    .appendTo(e)
                    .kendoDropDownList({
                        dataTextField: 'Description',
                        dataValueField: 'Id',
                        autoSync: false,
                        dataSource: {
                            type: 'json',
                            transport: {
                                read: function (opts) {
                                    var isPreservation = $formContainer
                                        .find('[name="isPreservation"]')
                                        .prop('checked');

                                    var url = crudBaseUrl + '/States/?isPreservation=' + isPreservation;
                                    MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'GET', opts);
                                }
                            }
                        },
                        change: function () {
                            setFieldValue(opts.model.id, opts.field, this.value());
                        },
                        dataBound: function () {
                            setFieldValue(opts.model.id, opts.field, this.value());
                        }
                    });
            };

            function setFieldValue(modelId, field, val) {
                dataSource.get(modelId).set(field, val);
            }
        }
    });
})(jQuery, MDB);